import SendMail from './components/password/SendMail.vue';
import SetPassword from './components/password/Set.vue';
import NotificationToast from './components/toast/NotificationToast.vue';

const componentsGuest = (app) => {
  app.component('SendMail', SendMail);
  app.component('SetPassword', SetPassword);
  app.component('NotificationToast', NotificationToast);
};

export default componentsGuest;
